import { render, staticRenderFns } from "./interactiveanswer.vue?vue&type=template&id=267959c8&scoped=true"
import script from "./interactiveanswer.vue?vue&type=script&lang=js"
export * from "./interactiveanswer.vue?vue&type=script&lang=js"
import style0 from "./interactiveanswer.vue?vue&type=style&index=0&id=267959c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267959c8",
  null
  
)

export default component.exports